import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const EditFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M15.82 5.38C16.8 4.4 18.38 4.4 19.38 5.38C20.36 6.36 20.36 7.96 19.38 8.94L18.14 10.18L14.58 6.62L15.82 5.38ZM13.18 8.02L16.74 11.58L8.36 19.96L3.9 20.86L4.8 16.4L13.18 8.02Z" />
    </SvgIcon>
  );
});
